import React from 'react';
import PropTypes from 'prop-types';
import CartReaderInput from '@components/cart/rx/CartReaderInput';
import RxCells from '@components/cart/rx/RxCells';

const RxChoices = ({ rxType, readerStrength, item, bundleKey }) => {
	return (
		<div className='d-flex flex-column rx__container'>
			<div className='d-flex justify-content-between align-items-center'>
				<h2 className='title h2'>{rxType === 'readers' ? 'Reader Strength' : 'My Prescription'}</h2>
				{rxType === 'readers' ? (
					<CartReaderInput readerStrength={readerStrength} bundleKey={bundleKey} item={item} />
				) : (
					<div className='caption'>Required</div>
				)}
			</div>
			{rxType === 'readers' ? null : <RxCells item={item} bundleKey={bundleKey} />}
		</div>
	);
};

RxChoices.propTypes = {
	rxType: PropTypes.string,
	readerStrength: PropTypes.string,
	item: PropTypes.shape({}),
	bundleKey: PropTypes.string,
};

export default RxChoices;
